import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=57503b74&scoped=true&lang=scss"
script.__scopeId = "data-v-57503b74"

export default script